import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import useDidMountEffect from 'assets/js/useDidMountEffect';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

/* 에디터 */
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';

export default function MeetingWrite() {
  const navigate = useNavigate();

  const [requestContent, setRequestContent] = useState('');
  const [clientList, setClientList] = useState();
  const [isSubmit, setIsSubmit] = useState(false);
  const [result, setResult] = useState({
    custMstSeq: '',
    title: '',
    contents: ''
  });

  useEffect(() => {
    getClientList();
  }, []);

  useDidMountEffect(() => {
    setResult(() => {
      return {
        ...result,
        contents: requestContent
      }
    })
  }, [requestContent]);

  //고객사 조회
  const getClientList = () => {
    Server.sendGet('client/management', {}, getClientListCallback).then();
  };

  const getClientListCallback = res => {
    setClientList(res['resultList']);
  };

  const validation = () => {
    const msgArr = ['Client must be selected.', 'Title is required', 'Contents is required.'];
    const columns = ['custMstSeq', 'title', 'contents'];

    for (let i = 0; i < columns.length; i++) {
      if (Common.isEmpty(result[columns[i]])) {
        Common.errorMsg(msgArr[i]);

        return false;
      }
    }

    return true;
  };

  const postData = () => {
    if (validation() && !isSubmit) {
      setIsSubmit(true);

      Server.sendPost('client/meet', result, postDataCallback).then();
    }
  };

  const postDataCallback = res => {
    setIsSubmit(false);

    Common.alertSuccess();

    navigate('/client/meeting');
  };

  const customUploadAdapter = (loader) => {
    return {
      upload() {
        return new Promise((resolve) => {
          const formData = new FormData();

          loader.file.then((file) => {
            formData.append('file', file);

            Server.sendErpS3Upload(formData).then(res => {
              resolve({
                default: res.data['resultObject']['s3Url'],
              });
            }).catch(() => {
              Common.errorMsg('업로드에 실패하였습니다. 잠시후에 다시 시도해주세요.');
            });
          });
        });
      }
    };
  };

  function uploadPlugin(editor) {
    editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
      return customUploadAdapter(loader);
    };
  }

  return (
    <MeetWrap>
      <div className='content-inner'>
        <div className='title'>
          <div className='title-head'>
            <i/>
            <h4>Minute Of Meeting</h4>
          </div>
        </div>
        <div className='content noArea'>
          <div className='form-head'>
            <input
              type='text'
              name='subject'
              id='subject'
              placeholder='Please enter a title'
              onChange={e => {
                setResult(() => {
                  return {
                    ...result,
                    title: e.target.value,
                  }
                })
              }}
            />
            <CateIn>
              <Cate>
                <CateSel
                  name='clientForm'
                  id='clientForm'
                  value={result?.custMstSeq}
                  onChange={e => {
                    setResult(() => {
                      return {
                        ...result,
                        custMstSeq: e.target.value,
                      };
                    });
                  }}
                >
                  <option value={''}>Select Client</option>
                  {clientList?.map(item => (
                    <option key={item.custMstSeq} value={item.custMstSeq}>{item.custName}</option>
                  ))}
                </CateSel>
              </Cate>
            </CateIn>
          </div>
          <CKEditor
            editor={ClassicEditor}
            config={{
              extraPlugins: [uploadPlugin]
            }}
            data={requestContent}
            onBlur={(event, editor) => {
              setRequestContent(editor.getData());
            }}
            onChange={(event, editor) => {
              setRequestContent(editor.getData());
            }}
          />

          <div className='edit-btn'>
            <button
              className='submit'
              onClick={postData}
            >Write
            </button>
            <button
              className='list'
              onClick={() => navigate('/client/meeting')}
            >List
            </button>
          </div>
        </div>
      </div>
    </MeetWrap>
  )
}

const MeetWrap = styled.div`
  position: relative;
  flex: 1;

  .form-head {
    margin-bottom: 30px;
    position: relative;

    input {
      width: 100%;
      height: 45px;
      line-height: 45px;
      padding: 0 16px;
      font-weight: 400;
      font-size: 18px;
      color: #000000;
      margin-bottom: 15px;

      &::placeholder {
        font-weight: 400;
        font-size: 16px;
        color: #111111;
      }
    }
  }

  .ck .ck-content {
    height: 420px;
  }

  .btn-list {
    margin-top: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    button {
      display: block;
      width: 125px;
      height: 45px;
      line-height: 45px;
      background: #0072B9;
      font-weight: 600;
      font-size: 16px;
      color: #ffffff;
      border-radius: 10px;
    }
  }
`
const CateIn = styled.div`
  display: flex;
  align-items: center;
  gap: 0 20px;
`;

const Cate = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & label {
    font-weight: 400;
    font-size: 16px;
    color: #777777;
  }
`;

const CateSel = styled.select`
  width: 200px;
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  font-weight: 400;
  font-size: 16px;
  color: #777777;
  background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  outline: none;
`;